import { render, staticRenderFns } from "./CheckFlow.vue?vue&type=template&id=485b796e&scoped=true"
import script from "./CheckFlow.vue?vue&type=script&lang=js"
export * from "./CheckFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b796e",
  null
  
)

export default component.exports